import cn from "classnames"

import { Flex, Text } from "@/atoms"
import { Heading } from "@/molecules/Heading"

import styles from "./NextStepsTabAdr.module.scss"

import type { TitleProps } from "./NextStepsTabAdr.types"

export const TitleStep = (props: TitleProps) => (
  <Flex vertical className={styles.titleStep}>
    <Heading level={4} title={props.title} classes={{ title: styles.title }} />
    <Text type="secondary" className={cn(styles.subtitle, "sm-text-ks")}>
      {props.description}
    </Text>
  </Flex>
)
